module.exports = __webpack_public_path__ + "static/media/11.51ffb58a.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/11.png
// module id = 970
// module chunks = 0